import { render, staticRenderFns } from "./OrmDeclineQuoteRequestModal.vue?vue&type=template&id=612b210d&scoped=true"
import script from "./OrmDeclineQuoteRequestModal.vue?vue&type=script&lang=js"
export * from "./OrmDeclineQuoteRequestModal.vue?vue&type=script&lang=js"
import style0 from "./OrmDeclineQuoteRequestModal.vue?vue&type=style&index=0&id=612b210d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b210d",
  null
  
)

export default component.exports